import * as React from 'react';
import * as Yup from 'yup';

import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import { Formik, FormikProps } from 'formik';
import { FormInput } from 'common/components/form/FormInput';
import { Loading } from '../Loading';
import { VoucherApi } from 'common/api/resources/Voucher';
import moment = require('moment');

interface CertificatePackageSentDateDialogProps {
  isOpen: boolean;
  voucher: any;
  onSave: () => void;
  onCancel: () => void;
  title?: string;
  saveLabel?: string;
}
class FormValues {
  certificatePackageSentDate = '';
}

export interface CertificatePackageSentDateTimeDialogState {
  error?: string;
  isLoading: boolean;
}

export class CertificatePackageSentDateDialog extends React.Component<
  CertificatePackageSentDateDialogProps,
  CertificatePackageSentDateTimeDialogState
> {
  validationSchema = Yup.object().shape({
    certificatePackageSentDate: Yup.string().required('Required'),
  });

  state: CertificatePackageSentDateTimeDialogState = {
    error: '',
    isLoading: false,
  };

  initialValues() {
    return {
      certificatePackageSentDate:
        this.props.voucher && this.props.voucher.certificationPackageSentDate
          ? moment(this.props.voucher.certificationPackageSentDate).format('YYYY-MM-DD')
          : '',
    };
  }

  handleSubmit = async (values: FormValues) => {
    // console.log('Certificate Package Sent Date', values.certificatePackageSentDate);
    await this.setState({ isLoading: true });
    if (this.props.voucher) {
      const updateVoucher = {
        certificationPackageSentDate: moment(values.certificatePackageSentDate)
          .set({
            hour: moment().get('hour'),
            minute: moment().get('minute'),
            second: moment().get('second'),
          })
          .toISOString(),
      };
      VoucherApi.updateVoucher(this.props.voucher.id, updateVoucher)
        .then(() => {
          this.setState({ isLoading: false });
          this.props.onSave();
        })
        .catch(e => {
          console.error(e);
          this.setState({ isLoading: false });
        });
    }
  };

  render() {
    const props = this.props;
    return (
      <Modal size="md" isOpen={props.isOpen} toggle={props.onCancel} keyboard={true}>
        <Formik
          initialValues={this.initialValues()}
          validationSchema={this.validationSchema}
          onSubmit={this.handleSubmit}
          render={(form: FormikProps<FormValues>) => (
            <form onSubmit={form.handleSubmit}>
              <ModalHeader toggle={this.props.onCancel}>
                {this.props.title ? this.props.title : 'Input Date'}
              </ModalHeader>
              <ModalBody>
                <FormInput
                  id="certificatePackageSentDate"
                  name="certificatePackageSentDate"
                  label="Certificate Package Sent"
                  type="date"
                />
              </ModalBody>
              <ModalFooter>
                <div>
                  <span>
                    <Button color="secondary" onClick={this.props.onCancel}>
                      Cancel
                    </Button>{' '}
                    <Button color="primary" type="submit">
                      {this.props.saveLabel ? this.props.saveLabel : 'Save'}
                    </Button>
                  </span>
                </div>
              </ModalFooter>
              {this.state!.isLoading && (
                <div style={{ margin: 10 }}>
                  <Loading message="Saving..." />
                </div>
              )}
              {this.state!.error && <div className="alert alert-danger">{this.state!.error}</div>}
            </form>
          )}
        />
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/dialogs/CertificatePackageSentDateTimeDialog.tsx